type UpdateRowDataProps = {
	uuid: string;
	key: string;
	newValue: any;
	setRowData: React.Dispatch<React.SetStateAction<any[]>>;
	keysArray: string[];
};

export const updateRowData = ({
	uuid,
	key,
	newValue,
	setRowData,
	keysArray,
}: {
	uuid: string;
	key: string;
	newValue: any;
	setRowData: React.Dispatch<React.SetStateAction<any[]>>;
	keysArray: string[];
}) => {
	setRowData((prevData) => {
		// Create updatedData first
		const updatedData = prevData.map((row) => {
			if (row.data.uuid === uuid) {
				return {
					...row,
					data: {
						...row.data,
						[key]: newValue,
					},
				};
			}
			return row;
		});

		return updatedData;
	});
};
